import React from 'react';
import omit from 'lodash/omit';

const Padding = (props) => {
  const { children, className = '' } = props;
  const p = {
    ...omit(props, 'children'),
    className: `px-3 px-lg-4 px-xl-5 ${className}`,
  };

  return <div {...p}>{children}</div>;
};

export default Padding;
